module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "piv"
    }
  }), _vm._v(" First Mariner Books edition 2003")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Copyright © 2002 by Carol Anshaw"), _c('br'), _vm._v("\nAll rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.hmhco.com/popular-reading",
      "target": "_blank"
    }
  }, [_vm._v("www.hmhco.com")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("The Library of Congress has cataloged the print edition as follows:")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Anshaw, Carol."), _c('br'), _vm._v("\nLucky in the corner / Carol Anshaw."), _c('br'), _vm._v("\np. cm."), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 0-395-94040-0"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 0-618-34070-x (pbk.)")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("1. Mothers and daughters—Fiction. 2. Lesbian mothers—Fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("PS")]), _vm._v("3551."), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("N")]), _vm._v("7147 "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("L")]), _vm._v("83 2002"), _c('br'), _vm._v("\n813'.54—dc21 2001051891")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("e"), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-544-03203-3"), _c('br'), _vm._v("\nv2.0514")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2081d925","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 63
// module chunks = 0